import './App.css';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import '../node_modules/bootstrap/dist/js/bootstrap.bundle.js';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './Component/Login.jsx';
import Home from './Component/Home.jsx';
import SurveyList from './Component/SurveyList.jsx';
import PageNot from './PageNot.jsx';
import ManageSurvey from './Component/ManageSurvey.jsx';
import CreateNew from './Component/CreateNew.jsx';
import Footer from "./Component/Footer.jsx";
import AddPerimisson from './Component/Add-Permission.jsx';
import ManageReminder from './Component/ManageReminder.jsx';
import SignUp from './Component/SignUp.jsx';
import LiveSurvey from './Component/LiveSurvey.jsx';
import UserRunSurvey from './Component/UserRunSurvey.jsx';
import PrivacyPolicy from './Component/PrivacyPolicy.jsx';
import TermsAndCondtion from './Component/TermsAndCondition.jsx';
import Profile from './Component/Profile.jsx';
import ForgetPassword from './Component/ForgetPassword.jsx';
import ManageFormula from './Component/ManageFormula.jsx';
import AdminPanel from './Component/AdminPanel.jsx';
import CompanyProfile from './Component/CompanyProfile.jsx';
import ManageUser from './Component/ManageUser.jsx';
import ManageCompanyProfile from './Component/ManageCompanyProfile.jsx';
import CreateNewMember from './Component/CreateNewMember.jsx';
import CompanyPlans from './Component/CompanyPlans.jsx';
import CreateCompany from './Component/CreateCompany.jsx';
import VerifyAccount from './Component/VerifyAccount.jsx';
import UpperFooter from './Component/UpperFooter.jsx';
import ParticipantResponse from './Component/Participant_Response.jsx';

function App() {
  return (
      <Router>
      <Routes>
          {/* <Route path="/Survey_List" element={<SurveyList />} /> */}
          <Route path="/" element={<Home />} />
          <Route path="/Home" element={<Home />} />
          <Route path="/Login" element={<Login />} />
          <Route path="/SignUp" element={<SignUp />} />
          <Route path="/SurveyList" element={<SurveyList />} />
          <Route path='/ManageSurvey/:uniqueKey' element={<ManageSurvey/>} />
          <Route path='/Survey/CreateNew' element={<CreateNew/>} />
          <Route path='/Survey/AddPermission/:uniqueKey' element={<AddPerimisson/>} />
          <Route path='/Survey/ManageReminder/:uniqueKey' element={<ManageReminder/>} />
          <Route path='/LiveSurvey/:uniqueKey' element={<LiveSurvey/>} />
          <Route path='/UserRunSurvey/:uniqueKey' element={<UserRunSurvey/>} />
          <Route path='/PrivacyPolicy' element={<PrivacyPolicy/>} />
          <Route path='/TermsAndCondtion' element={<TermsAndCondtion/>} />
          <Route path='/Profile' element={<Profile/>} />
          <Route path='/ForgetPassword' element={<ForgetPassword/>} />
          <Route path='/ManageFormula/:uniqueKey' element={<ManageFormula/>} />
          <Route path='/AdminPanel' element={<AdminPanel/>} />
          <Route path='/CompanyProfile' element={<CompanyProfile/>} />
          <Route path='/ManageCompanyProfile/:uniqueKey' element={<ManageCompanyProfile/>} />
          <Route path='/ManageUser' element={<ManageUser/>} />
          <Route path='/CreateNewMember' element={<CreateNewMember/>} />
          <Route path='/CompanyPlans' element={<CompanyPlans/>} />
          <Route path='/CreateCompany' element={<CreateCompany/>} />
          <Route path='/VerifyAccount/:ActivationKey' element={<VerifyAccount/>} />
          <Route path='/UpperFooter' element={<UpperFooter/>} />
          <Route path='/ParticipantResponse/:uniqueKey' element={<ParticipantResponse/>} />
          {/* Add more routes */}
          <Route path='*' element={<PageNot/>} />
        </Routes>
        <Footer />
    </Router>
  );
}

export default App;
